import React from 'react';
import Helmet from 'react-helmet';

import { useSiteMetadata } from 'hooks';

const Head = ({ lang, metaDescription, pageTitle, url }) => {
  const { description, siteUrl, title } = useSiteMetadata();

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{url !== '/' ? `${pageTitle} | ${title}` : title}</title>
      <meta
        content={metaDescription ? metaDescription : description}
        name="description"
      />
      <meta
        content="width=device-width, initial-scale=1, viewport-fit=cover"
        name="viewport"
      />
      <meta content="IE=edge" httpEquiv="X-UA-Compatible" />
      <meta content={`${pageTitle} | ${title}`} name="twitter:title" />
      <meta content={metaDescription} name="twitter:description" />
      <meta content={siteUrl} name="twitter:domain" />
      <meta content={url} property="og:url" />
      <meta content={title} property="og:site_name" />
      <meta content={`${pageTitle} | ${title}`} property="og:title" />
      <meta content={metaDescription} property="og:description" />
      <link rel="manifest" href="/favicons/site.webmanifest" />
      <link rel="shortcut icon" href="/favicons/favicon.ico" />
      <meta name="msapplication-TileColor" content="#b91d47" />
      <meta name="msapplication-config" content="/favicons/browserconfig.xml" />
      <meta name="theme-color" content="#ffffff" />
      <meta property="og:image" content={`${siteUrl}/og-image.jpg`} />
      <meta name="twitter:image" content={`${siteUrl}/og-image.jpg`} />
      <meta name="twitter:card" content="summary" />
      <link
        href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,700;1,400&amp;display=swap"
        rel="stylesheet"
      />
      <html lang={lang} />
    </Helmet>
  );
};

export default Head;
